module.exports = __webpack_public_path__ + "img/sz.728b0192.png";